"use strict";

window.CI = window.CI || {};

(function ($$) {

  class ContactForm {
    constructor() {
      this.elem = {
        submit: document.getElementById('submitButton'),
        agreement: document.getElementById('agreement'),
      }

      this.init();
    }

    init() {
      this.agreement();
    }

    agreement() {
      this.elem.agreement.addEventListener('change', (e) => {
        let isChecked = e.target.checked;
        if(isChecked) {
          this.elem.submit.classList.remove('c-fill-button--disable');
          this.elem.submit.classList.add('c-fill-button--primary');
        } else {
          this.elem.submit.classList.add('c-fill-button--disable');
          this.elem.submit.classList.remove('c-fill-button--primary');
        }
      });
    }
  }
  const contactform = new ContactForm();

  ['DOMContentLoaded', 'load', 'resize', 'scroll'].map((event) => {
    window.addEventListener(event, (e) => {

      if (event === 'DOMContentLoaded') {
      } else if (event === 'load') {
      } else if (event === 'scroll') {
      } else if (event === 'resize') {
      }

    });
  });
  $$.settings.mql.addEventListener("change", () => {
  });

})(window.CI);
